import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_steps = _resolveComponent("steps")!
  const _component_ueberschrift = _resolveComponent("ueberschrift")!
  const _component_adresse = _resolveComponent("adresse")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_ja_nein_radio = _resolveComponent("ja-nein-radio")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_antragsteller = _resolveComponent("antragsteller")!
  const _component_vertragsunterlagen_digital = _resolveComponent("vertragsunterlagen-digital")!
  const _component_zahlungsdaten = _resolveComponent("zahlungsdaten")!
  const _component_vorversicherung = _resolveComponent("vorversicherung")!
  const _component_vorschaeden = _resolveComponent("vorschaeden")!
  const _component_hug_mitgliedschaft = _resolveComponent("hug-mitgliedschaft")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_steps, {
      active: 2,
      items: _ctx.navItems,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createElementVNode("section", null, [
      _createVNode(_component_ueberschrift, { titel: "Versichertes Gebäude" }),
      _createVNode(_component_adresse, {
        fehler: _ctx.fehler,
        placeholder: true,
        plz: _ctx.piniaStore.state.risikoAnschrift.plz,
        "onUpdate:plz": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.plz) = $event)),
        ort: _ctx.piniaStore.state.risikoAnschrift.ort,
        "onUpdate:ort": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.ort) = $event)),
        strasse: _ctx.piniaStore.state.risikoAnschrift.strasse,
        "onUpdate:strasse": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.strasse) = $event)),
        hausnummer: _ctx.piniaStore.state.risikoAnschrift.hausnummer,
        "onUpdate:hausnummer": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.hausnummer) = $event)),
        feldNamen: {
        plz: 'risikoPlz',
        ort: 'risikoOrt',
        strasse: 'risikoStrasse',
        hausnummer: 'risikoHausnummer',
      },
        ref: "risikoAdresseRef"
      }, {
        plzOrtLabel: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode("PLZ und Ort")
        ])),
        strasseHausnummerLabel: _withCtx(() => _cache[10] || (_cache[10] = [
          _createTextVNode("Straße und Hausnummer")
        ])),
        _: 1
      }, 8, ["fehler", "plz", "ort", "strasse", "hausnummer"]),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, null, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode("Sind Sie Alleineigentümer des Gebäudes")
            ])),
            _: 1,
            __: [11]
          }),
          _createVNode(_component_zelle, null, {
            default: _withCtx(() => [
              _createVNode(_component_ja_nein_radio, {
                name: "alleineigentuemer",
                modelValue: _ctx.piniaStore.state.gebaeudedaten.alleineigentuemer,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.alleineigentuemer) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_validierungs_fehler, {
                "fehler-text": _ctx.fehler.alleineigentuemer
              }, null, 8, ["fehler-text"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.piniaStore.state.gebaeudedaten.alleineigentuemer === false)
        ? (_openBlock(), _createBlock(_component_zeile, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode("Art der Miteigentümerschaft")
                ])),
                _: 1,
                __: [12]
              }),
              _createVNode(_component_zelle, null, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("select", {
                    name: "miteigentuemerTyp",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.miteigentuemerTyp) = $event)),
                    class: "c-form-control-select",
                    "data-cy": "miteigentuemerTyp",
                    "data-fehlermeldung": "Bitte wählen Sie eine Art der Miteigentümerschaft aus.",
                    required: "",
                    "aria-label": "Art der Miteigentümerschaft",
                    "aria-required": "true"
                  }, _cache[13] || (_cache[13] = [
                    _createElementVNode("option", { value: "" }, "Bitte wählen", -1),
                    _createElementVNode("option", { value: "EHE" }, "Ehe-/Lebenspartnerschaft", -1),
                    _createElementVNode("option", { value: "ETG" }, "Eigentümergemeinschaft (EG)", -1),
                    _createElementVNode("option", { value: "WEG" }, "Wohnungseigentümergemeinschaft (WEG)", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.piniaStore.state.gebaeudedaten.miteigentuemerTyp]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.miteigentuemerTyp,
                    "reduzierter-abstand": true
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_antragsteller, {
        fehler: _ctx.fehler,
        ref: "antragstellerRef"
      }, null, 8, ["fehler"]),
      _createVNode(_component_vertragsunterlagen_digital, { fehler: _ctx.fehler }, null, 8, ["fehler"]),
      _createVNode(_component_zahlungsdaten, {
        fehler: _ctx.fehler,
        ref: "zahlungsdatenRef"
      }, null, 8, ["fehler"]),
      _createVNode(_component_vorversicherung, { fehler: _ctx.fehler }, null, 8, ["fehler"]),
      _createVNode(_component_vorschaeden, { fehler: _ctx.fehler }, null, 8, ["fehler"]),
      (_ctx.zeigeFrageHugNachlass)
        ? (_openBlock(), _createBlock(_component_hug_mitgliedschaft, {
            key: 1,
            fehler: _ctx.fehler
          }, null, 8, ["fehler"]))
        : _createCommentVNode("", true),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_zelle, {
            breite: 4,
            offset: 4
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "c-button c-button--full-width u-mar-t-2 u-mar-b-2 mobil-mehrAbstand",
                "data-cy": "submitIhreDaten",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.nextPage()))
              }, " Zusammenfassung und Abschluss ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.istSichtbar('modalBeitragsaenderung'))
        ? (_openBlock(), _createBlock(_component_modal, _mergeProps({ key: 2 }, _ctx.modalBeitragsaenderung, {
            onCloseModal: _cache[8] || (_cache[8] = ($event: any) => (_ctx.wechsleSichtbarkeit('modalBeitragsaenderung')))
          }), null, 16))
        : _createCommentVNode("", true)
    ])
  ], 64))
}